import React, { useState } from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import { Entity } from "@common/types/entity";
import { StandardModal } from "@design-system/Modal/Modal";
import { Button } from "@design-system/Button/Button";
import { MergeAccountsModal } from "./MergeAccountsModal";

interface MergeAccountsButtonProps {
    variant?: "primary" | "secondary";
    size?: "sm" | "md" | "lg" | "xl";
    className?: string;
    disabled?: boolean;
}

interface Props {
    financialAccount: FinancialAccount;
    entity: Entity;
    buttonProps?: MergeAccountsButtonProps;
    buttonClass?: string;
}

export const MergeAccounts: React.FC<Props> = ({
    financialAccount,
    entity,
    buttonProps = { variant: "primary", size: "md" },
    buttonClass,
}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                variant="primary"
                size="md"
                className={buttonClass}
                {...buttonProps}
                onClick={() => setShowModal((shown) => !shown)}
            >
                Merge account
            </Button>

            <StandardModal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
            >
                <MergeAccountsModal
                    financialAccount={financialAccount}
                    entity={entity}
                    close={() => setShowModal(false)}
                />
            </StandardModal>
        </>
    );
};
